export const TICKET_OPERATIONS = {
    CHAT_CONVERSER: 'CHAT_CONVERSER_EVENT',
    END_EVALUATING_POLICY: 'TICKET_COMMENT_END_EVALUATING_POLICY',
    START_EVALUATING_POLICY: 'TICKET_COMMENT_START_EVALUATING_POLICY',
    LLM_RESPONSE: 'LLM_RESPONSE',
    LLM_TRIGGER: 'LLM_TRIGGER',
    USER_PROMPT: 'USER_PROMPT',
    COMMENT_DECISION_EXECUTION: 'TICKET_COMMENT_DECISION_EXECUTION',
} as const;

export const EVENT_KINDS = {
    SYSTEM_PROMPT: 'system-prompt',
    INTENT_SUGGESTION: 'intent-suggestion',
    TOOL_RESPONSE: 'tool-response',
    TOOL_REQUEST: 'tool-request',
    PRE_FILTER: 'pre-filter',
    ESCALATION: 'escalation',
    ERROR: 'error',
    CONVERSER_VALIDATOR: 'converser-validator',
    FOLLOW_UP: 'follow-up',
} as const;

export type EventKind = (typeof EVENT_KINDS)[keyof typeof EVENT_KINDS];

export const EVENT_LABELS: Record<EventKind, string> = {
    [EVENT_KINDS.SYSTEM_PROMPT]: 'Instructions',
    [EVENT_KINDS.INTENT_SUGGESTION]: 'Tool Suggestions',
    [EVENT_KINDS.TOOL_RESPONSE]: 'Context Graph Response',
    [EVENT_KINDS.TOOL_REQUEST]: 'Tool Request',
    [EVENT_KINDS.PRE_FILTER]: 'Pre-filter',
    [EVENT_KINDS.ESCALATION]: 'Escalation',
    [EVENT_KINDS.ERROR]: 'Error',
    [EVENT_KINDS.CONVERSER_VALIDATOR]: 'Converser Validator',
    [EVENT_KINDS.FOLLOW_UP]: 'Follow-up',
} as const;

export const POLICY_TYPES = {
    PRE_FILTER: 'PRE_FILTER',
    FOLLOW_UP: 'FOLLOW_UP',
} as const;

export type TicketOperation = (typeof TICKET_OPERATIONS)[keyof typeof TICKET_OPERATIONS];
export type PolicyType = (typeof POLICY_TYPES)[keyof typeof POLICY_TYPES];
